import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import { AREA_CODE_OPTIONS } from '~/models/area'

/**
 * 業務エリア設定から損失率マスタの表示対象エリア集合を導出する (AC-MLR-001)。
 * 選択肢除外方式: 表示対象 = 画面の対象エリア (全 10 エリア) ∩ 業務エリア設定。
 * 並びは業務エリア設定の順序を保持する (design lrRender と同じ方針)。
 */
export function deriveVisibleAreaCodes(
  businessAreas: readonly AreaCode[],
): AreaCode[] {
  return businessAreas.filter((area) => AREA_CODE_OPTIONS.includes(area))
}
